import {FunctionalityTogglesApi} from '@/api/functionality-toggles';
import {mutationAndActionHelper} from '@/utils/vuex-helpers.js';

const togglePromises = {};
const MutationTypes = Object.freeze({
  SET_TOGGLE: 'setToggle',
});

const ActionTypes = Object.freeze({
  GET_TOGGLE_BY_ID: 'fetchToggleById',
});

export const functionalityToggleActions = mutationAndActionHelper(ActionTypes, 'functionalityToggle');

const functionalityToggleModule = {
  namespaced: true,
  state: {},
  getters: {
    getToggleById: (state) => (id) => {
      return state[id] || null;
    },
  },
  mutations: {
    [MutationTypes.SET_TOGGLE](state, toggle) {
      state[toggle.id] = toggle;
    },
  },
  actions: {
    [ActionTypes.GET_TOGGLE_BY_ID]({state, commit}, toggleId) {
      const existingToggle = state[toggleId];
      if (existingToggle) {
        return existingToggle;
      }

      if (!togglePromises[toggleId]) {
        togglePromises[toggleId] = FunctionalityTogglesApi.getToggleById(toggleId)
          .then((toggle) => {
            if (toggle) {
              commit(MutationTypes.SET_TOGGLE, toggle);
            }
            return toggle;
          })
          .catch((error) => {
            console.error('Failed to fetch toggle configuration', toggleId, error);
            throw error;
          })
          .finally(() => {
            delete togglePromises[toggleId];
          });
      }

      return togglePromises[toggleId];
    },
  },
};

export default functionalityToggleModule;
